/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker,
} from 'leaflet';
import { IModalData } from '@/services/layers/IModalData';

export default class ParkingZoneLayerService extends LayerService {
  // markerIcon = 'strefy-parkowania.svg';

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const template: string = metaData.description;
    const modalIconUrl = require(`@/assets/img/icon-layers/single-icons/marker_parking_zone.svg`);

    const lastUpdate: string = metaData.last_status && metaData.last_status.date_time
                       ? metaData.last_status.date_time
                       : '';

    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: undefined,
      lastUpdate: lastUpdate,
      templateName: 'TemplateModalParkingZone',
      icon: modalIconUrl,
      hideModalBtn: true,
      metaData: metaData,
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const { parkingZones } = store.state;
    return this.generatePolygonsLayer(parkingZones);
  };
}
